class BundleOffer extends HTMLElement {
    constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.container = this.querySelector(`#bundle-container-${this.sectionId}`);
        this.dataScript = this.querySelector(`#bundle-data-${this.sectionId}`);

        if (!this.dataScript) return;
        this.bundleData = JSON.parse(this.dataScript.textContent);

        this.selectors = [
            this.querySelector(`[data-product-index="1"] select`) || this.querySelector(`[data-product-index="1"] input[type="hidden"]`),
            this.querySelector(`[data-product-index="2"] select`) || this.querySelector(`[data-product-index="2"] input[type="hidden"]`)
        ];

        this.priceEls = [this.querySelector(`[data-price-index="1"]`), this.querySelector(`[data-price-index="2"]`)];
        this.compareEls = [this.querySelector(`[data-compare-index="1"]`), this.querySelector(`[data-compare-index="2"]`)];
        this.totalPriceEl = this.querySelector(`#bundle-total-price-${this.sectionId}`);
        this.totalCompareEl = this.querySelector(`#bundle-compare-price-${this.sectionId}`);
        this.saveBadgeEl = this.querySelector(`#bundle-save-badge-${this.sectionId}`);
        this.saveAmountEl = this.querySelector(`#bundle-save-amount-${this.sectionId}`);
        this.addButton = this.querySelector(`#bundle-add-to-cart-${this.sectionId}`);

        this.currencySymbol = this.dataset.currencySymbol || '$';
        this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
        this.routesRoot = window.Shopify.routes.root;

        this.init();
    }

    init() {
        this.selectors.forEach(sel => {
            if (sel) sel.addEventListener('change', this.updateUI.bind(this));
        });

        if (this.addButton) {
            this.addButton.addEventListener('click', this.handleAddToCart.bind(this));
        }

        if (this.selectors[0] && this.selectors[1]) this.updateUI();
    }

    formatMoney(cents) {
        return this.currencySymbol + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    formatPrice(price) {
        if (typeof window.Currency !== 'undefined' && typeof window.Currency.formatMoney === 'function') {
            return window.Currency.formatMoney(price, this.moneyFormat);
        }
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
            return Shopify.formatMoney(price, this.moneyFormat);
        }
        return this.formatMoney(price);
    }

    getSelectedVariant(productIndex) {
        if (!this.selectors[productIndex]) return null;
        const variantId = parseInt(this.selectors[productIndex].value);
        const product = this.bundleData.products[productIndex];
        return product.variants.find(v => v.id === variantId);
    }

    updateUI() {
        let total = 0;
        let totalCompare = 0;
        let valid = true;

        [0, 1].forEach(index => {
            const variant = this.getSelectedVariant(index);
            if (!variant) {
                valid = false;
                return;
            }

            if (this.priceEls[index]) this.priceEls[index].innerHTML = this.formatPrice(variant.price);
            if (this.compareEls[index]) {
                if (variant.compare_at_price && variant.compare_at_price > variant.price) {
                    this.compareEls[index].innerHTML = this.formatPrice(variant.compare_at_price);
                    this.compareEls[index].classList.remove('hidden');
                } else {
                    this.compareEls[index].classList.add('hidden');
                }
            }

            total += variant.price;
            totalCompare += variant.compare_at_price || variant.price;
        });

        if (!valid) return;

        this.totalPriceEl.innerHTML = this.formatPrice(total);

        if (totalCompare > total) {
            this.totalCompareEl.innerHTML = this.formatPrice(totalCompare);
            this.totalCompareEl.classList.remove('hidden');

            const savedAmount = totalCompare - total;
            const percentage = Math.round(((totalCompare - total) / totalCompare) * 100);

            this.saveBadgeEl.classList.remove('hidden');
            this.saveAmountEl.textContent = `${percentage}% SAVE : ${this.formatPrice(savedAmount)}`;
        } else {
            this.totalCompareEl.classList.add('hidden');
            this.saveBadgeEl.classList.add('hidden');
        }
    }

    async handleAddToCart(e) {
        e.preventDefault();
        const v1 = this.getSelectedVariant(0);
        const v2 = this.getSelectedVariant(1);

        if (!v1 || !v2) return;

        this.addButton.classList.add('loading');
        this.addButton.setAttribute('aria-disabled', true);
        const originalText = this.addButton.textContent;
        this.addButton.textContent = 'ADDING...';

        const items = [
            { id: v1.id, quantity: 1 },
            { id: v2.id, quantity: 1 },
        ];

        const body = JSON.stringify({
            items: items,
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: window.location.pathname
        });

        try {
            const response = await fetch(this.routesRoot + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: body,
            });

            const json = await response.json();

            if (response.status === 200) {
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                    cartDrawer.renderContents(json);
                } else {
                    window.location.href = this.routesRoot + 'cart';
                }

                this.addButton.textContent = 'ADDED!';
                setTimeout(() => {
                    this.addButton.textContent = originalText;
                    this.addButton.classList.remove('loading');
                    this.addButton.removeAttribute('aria-disabled');
                }, 2000);

            } else {
                console.error(json);
                this.addButton.textContent = json.description || 'ERROR';
                setTimeout(() => {
                    this.addButton.textContent = originalText;
                    this.addButton.classList.remove('loading');
                    this.addButton.removeAttribute('aria-disabled');
                }, 3000);
            }

        } catch (e) {
            console.error(e);
            this.addButton.textContent = 'ERROR';
            setTimeout(() => {
                this.addButton.textContent = originalText;
                this.addButton.classList.remove('loading');
                this.addButton.removeAttribute('aria-disabled');
            }, 2000);
        }
    }
}

customElements.define('bundle-offer', BundleOffer);
